/* LADDOM hero slider — Module 13.
   Native JS, no slider library. Autoplay, swipe, keyboard, reduced-motion. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHero(root) {
    if (!root || root.dataset.heroReady === '1') return;
    root.dataset.heroReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length === 0) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    var toggle = root.querySelector('[data-hero-toggle]');
    var status = root.querySelector('[data-hero-status]');

    var index = 0;
    var timer = null;
    var speed = parseInt(root.dataset.speed, 10) || 6000;
    // Autoplay never starts under reduced motion — an auto-advancing carousel
    // is exactly what that preference is asking us not to do.
    var wantsAuto = root.dataset.autoplay === 'true' && slides.length > 1 && !REDUCED.matches;
    var playing = wantsAuto;
    var hovering = false;
    var focused = false;

    dots.forEach(function (d) {
      d.style.setProperty('--dur', speed + 'ms');
    });

    function announce() {
      if (status) status.textContent = 'Slide ' + (index + 1) + ' of ' + slides.length;
    }

    function paint() {
      slides.forEach(function (s, i) {
        var on = i === index;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
        // Anything off-screen must not be a tab stop.
        s.querySelectorAll('a, button').forEach(function (el) {
          if (on) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      });

      dots.forEach(function (d, i) {
        var on = i === index;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
        d.classList.remove('is-running');
        if (on && playing && !REDUCED.matches) {
          // Restart the fill animation from zero.
          void d.offsetWidth;
          d.classList.add('is-running');
        }
      });

      announce();
    }

    function go(to, viaUser) {
      var n = slides.length;
      index = ((to % n) + n) % n;
      paint();
      if (viaUser) restart();
    }

    function start() {
      stop();
      if (!playing || hovering || focused || document.hidden) return;
      timer = window.setInterval(function () {
        go(index + 1);
      }, speed);
      paint();
    }
    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }
    function restart() {
      // Manual interaction resets the dwell so a slide is never cut short.
      if (playing) start();
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1, true); });
    if (next) next.addEventListener('click', function () { go(index + 1, true); });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.getAttribute('data-hero-dot'), 10), true);
      });
    });

    if (toggle) {
      toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
      toggle.addEventListener('click', function () {
        playing = !playing;
        toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
        if (playing) start();
        else {
          stop();
          dots.forEach(function (d) { d.classList.remove('is-running'); });
        }
      });
    }

    // Pause while the pointer is over the hero or focus is inside it, so a
    // customer reading the copy never has it swapped out from under them.
    root.addEventListener('mouseenter', function () { hovering = true; stop(); });
    root.addEventListener('mouseleave', function () { hovering = false; start(); });
    root.addEventListener('focusin', function () { focused = true; stop(); });
    root.addEventListener('focusout', function () {
      if (!root.contains(document.activeElement)) { focused = false; start(); }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    // Keyboard: arrows move between slides when focus is inside the hero.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, true); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); }
    });

    // Swipe. Pointer events so it works for touch and pen alike. Horizontal
    // intent only — a mostly-vertical drag must stay a page scroll.
    var x0 = null, y0 = null, locked = false;
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      x0 = e.clientX; y0 = e.clientY; locked = false;
    }, { passive: true });

    root.addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      var dy = e.clientY - y0;
      if (!locked && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) locked = true;
    }, { passive: true });

    root.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      if (locked && Math.abs(dx) > 45) go(dx < 0 ? index + 1 : index - 1, true);
      x0 = null; y0 = null; locked = false;
    }, { passive: true });

    // If the visitor turns reduced motion on mid-session, stop advancing.
    function onReduced() {
      if (REDUCED.matches) {
        playing = false;
        stop();
        dots.forEach(function (d) { d.classList.remove('is-running'); });
        if (toggle) toggle.setAttribute('aria-pressed', 'true');
      }
    }
    if (REDUCED.addEventListener) REDUCED.addEventListener('change', onReduced);

    paint();
    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ld-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  // Let the merchant see the slide they selected in the editor.
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-hero-slide]');
    if (!slide) return;
    var root = slide.closest('[data-ld-hero]');
    if (!root) return;
    var all = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var dot = root.querySelector('[data-hero-dot="' + all.indexOf(slide) + '"]');
    if (dot) dot.click();
  });
})();
